import { ContentLayoutVariant } from '@silvertours/common-landingpages-view';

type VariantConfig = {
  hasStageAbove: boolean;
  includeTrustSeals: boolean;
  isMinimal: boolean;
  isPlain: boolean;
  isPromo: boolean;
  isErrorPage: boolean;
  showMarketingSlider: boolean;
  showBreadcrumbs: boolean;
};

export const resolveVariantConfig = (
  variant: ContentLayoutVariant,
): VariantConfig => {
  switch (variant.kind) {
    case 'default':
      return {
        hasStageAbove: true,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: true,
        showBreadcrumbs: true,
      };
    case 'reviewsPillar':
      return {
        hasStageAbove: true,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: true,
        showBreadcrumbs: true,
      };
    case 'plain':
      return {
        hasStageAbove: variant.hasStageAbove,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: true,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'promo':
      return {
        hasStageAbove: variant.hasStageAbove,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: true,
        isPromo: true,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'minimal':
      return {
        hasStageAbove: false,
        includeTrustSeals: false,
        isMinimal: true,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: true,
      };
    case 'error':
      return {
        hasStageAbove: true,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: true,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'newsletter':
      return {
        hasStageAbove: true,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: true,
        showBreadcrumbs: true,
      };
    default: {
      const unhandledVariant: never = variant;
      throw new Error(`Unhandled variant: ${(unhandledVariant as any).kind}`);
    }
  }
};
